import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = false;
  const isLoading = false;

  const location = useLocation();

  if (isLoading) return null;

  // Show loading indicator while authentication is being checked
  // if (isLoading) {
  //   return (
  //     <div className="flex items-center justify-center h-screen">
  //       <AiOutlineLoading3Quarters className="h-8 w-8 text-blue-600 animate-spin" />
  //     </div>
  //   );
  // }

  // If user is authenticated, redirect to the previous route or dashboard
  if (isAuthenticated) {
    const intendedPath = location.state?.from?.pathname || '/';
    return <Navigate to={intendedPath} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
